import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsToggle1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSettingsToggle1"><Path d="M1.5 12C1.5 8.41015 4.41015 5.5 8 5.5H16C19.5899 5.5 22.5 8.41015 22.5 12C22.5 15.5899 19.5899 18.5 16 18.5H8C4.41015 18.5 1.5 15.5899 1.5 12Z" stroke="currentColor"/><Path d="M12.5 12C12.5 10.067 14.067 8.5 16 8.5C17.933 8.5 19.5 10.067 19.5 12C19.5 13.933 17.933 15.5 16 15.5C14.067 15.5 12.5 13.933 12.5 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSettingsToggle1;
